import React from "react";
import Box from "./Box";

interface Props {};

const Card: React.FC<Props> = (props) => {
  const { children, ...rest } = props;
  return (
    <Box p={2} backgroundColor={"white"} {...rest}>
      {children}
    </Box>
  );
};

export default Card as any as typeof Box;
